import React from "react";

import { ToggleButton, ToggleLabel, ToggleThumb, ToggleTrack } from "./styles";
import { InlineToggleProps } from "./types";

export const InlineToggle: React.FC<InlineToggleProps> = ({
  checked,
  onChange,
  label,
  accent = "primary",
  ariaLabel,
  testId,
}) => {
  const handleClick = () => {
    onChange(!checked);
  };

  return (
    <ToggleButton
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel ?? label}
      onClick={handleClick}
      data-testid={testId}
    >
      <ToggleTrack $checked={checked} $accent={accent}>
        <ToggleThumb $checked={checked} />
      </ToggleTrack>
      <ToggleLabel>{label}</ToggleLabel>
    </ToggleButton>
  );
};
